export const ITEM_URL = (id: number): string => `/items/${id}`
export const DSA_APPEAL_EDUCATION_URL = (threadId: number) =>
  `/dsa/appeal_education?thread_id=${threadId}`
